import React from 'react';
import { useReveal, PageHero, PillLink } from '../Components/shared';
import { Social } from '../Components/icons';
import { SOCIALS } from '../data/site';

function Blog() {
  const ref = useReveal();
  return (
    <main id="main" ref={ref}>
      <PageHero
        eyebrow="Blog"
        title={['Stories are', 'on the way.']}
        lead="Updates from our programmes, learner stories and notes from our engineering team will live here."
        photo="playingAmpe"
      />
      <section className="section">
        <div className="wrap empty-state" data-reveal>
          <h2 className="h3">Until then, follow along</h2>
          <p className="body">We share news and behind-the-scenes moments on our social channels.</p>
          <ul className="socials on-light">
            {SOCIALS.map((s) => (
              <li key={s.label}>
                <a href={s.href} target="_blank" rel="noopener noreferrer" aria-label={`EMANAC on ${s.label}`}><Social name={s.label} /></a>
              </li>
            ))}
          </ul>
          <PillLink to="/joinUs">Join the community</PillLink>
        </div>
      </section>
    </main>
  );
}

export default Blog;
